(function () {
  'use strict';

  var CFG = {
    // Full UPC blocklist, inlined directly (self-contained — no external
    // file fetch, no dependency on how the theme includes this script).
    blockedUPCs: [
      '644472475067', '644472475074', '644472475050', '644472475036', '644472011715', '644472011708', '644472008654', '644472001952', '644472006810', '644472015249',
      '644472015256', '644472991833', '644472991857', '644472991932', '644472991956', '644472425031', '644472425017', '644472425055', '644472425024', '644472425062',
      '644472875034', '644472875058', '644472990768', '644472775037', '644472775051', '644472775075', '644472008661', '644472555998', '644472173048', '644472600070',
      '644472013207', '644472014105', '644472016567', '644472016529', '644472009064', '644472013566', '644472000672', '644472011050', '644472990102', '644472015331',
      '644472015324', '644472015317', '644472000559', '644472000528', '644472000511', '644472006858', '644472275032', '644472275018', '644472275056', '644472275025',
      '644472275063', '644472010749', '644472010756', '644472991215', '644472012330', '644472011739', '644472012101', '644472991420', '644472013221', '644472017571',
      '644472017670', '644472015294', '644472015300', '644472002430', '644472992991', '644472993004', '644472002508', '644472002515', '644472002591', '644472002584',
      '644472100938', '644472011487', '644472014297', '644472014082', '644472000641', '644472000702', '644472000689', '644472011005', '644472111248', '644472011685',
      '644472008319', '644472991208', '644472991192', '644472991413', '644472017328', '644472013993', '656825620949', '656825620901', '656825620857', '656825620840',
      '644472850031', '644472850055', '644472006841', '644472006834', '644472002898', '644472003222', '644472992236', '644472992250', '644472992359', '644472019155',
      '644472017519', '644472111200', '644472000764', '644472002225', '644472018264', '644472018219', '644472006094', '644472225037', '644472017465', '644472017427',
      '644472225051', '644472225020', '644472225068', '644472005097', '644472005103', '644472005080', '644472101461', '644472011142', '644472012484', '644472012316',
      '644472012071', '644472991123', '644472012019', '644472012088', '644472003345', '644472002775', '644472010039', '644472002409', '644472993172', '644472993165',
      '644472993158', '644472993141', '644472992786', '644472992793', '644472009446', '644472009453', '644472009415', '644472009439', '644472014518', '644472014525',
      '644472014495', '644472014501', '644472992809', '644472992816', '644472992830', '644472992823', '644472992922', '644472992939', '644472992953', '644472992946',
      '644472992885', '644472992892', '644472992915', '644472992908', '644472992847', '644472992854', '644472992878', '644472992861', '644472992472', '644472992489',
      '644472992502', '644472992496', '644472992632', '644472992649', '644472992656', '644472992663', '644472992762', '644472992779', '644472992724', '644472992731',
      '644472992755', '644472992748', '644472000740', '644472006339', '644472105278', '644472014822', '644472002874', '644472002881', '644472002843', '644472002669',
      '644472002676', '644472002706', '644472002713', '644472002232', '644472025033', '644472025057', '644472100839', '644472100853', '644472017304', '644472017236',
      '644472005271', '644472005288', '644472003895', '644472003871', '644472010688', '644472010664', '644472010633', '644472013641', '644472019032', '644472015744',
      '644472015751', '644472016178', '644472016208', '644472016161', '644472016024', '644472016000', '644472016017', '644472015768', '644472015775', '644472013061',
      '644472012132', '644472010589', '644472010619', '644472017533', '644472004205', '644472009040', '644472009026', '644472009019', '644472009002', '644472005967',
      '644472005974', '644472003673', '644472018967', '644472804010', '644472005936', '644472005950', '644472402025', '644472324563', '644472013573', '644472013559',
      '644472014228', '644472014204', '644472014174', '644472014167', '644472014075', '644472014051', '644472014037', '644472013177', '644472013153', '644472012675',
      '644472012668', '644472012477', '644472012415', '644472012361', '644472012347', '644472011944', '644472011814', '644472011470', '644472990614', '644472000658',
      '644472000696', '644472005530', '644472011517', '644472201390', '644472011210', '644472011265', '644472011258', '644472011241', '644472011234', '644472011500',
      '644472011494', '644472011074', '644472011067', '644472011043', '644472011036', '644472011029', '644472011012', '644472111231', '644472011623', '644472019162',
      '644472019131', '644472019124', '644472991277', '644472990973', '644472990966', '644472990959', '644472991383', '644472991376', '644472990935', '644472991338',
      '644472990867', '644472001921', '644472001914', '644472001938', '644472017472', '644472017144', '644472000573', '644472000566', '644472011432', '644472007152',
      '644472007169', '644472017250', '644472016963', '644472017229', '644472016956', '644472017212', '644472017274', '644472990362', '644472990355', '644472990348',
      '644472990331', '644472990300', '644472990294', '644472990027', '644472990287', '644472990270', '644472990010', '644472990256', '644472990225', '644472990201',
      '644472011883', '644472009965', '644472009972', '644472009989', '644472009958', '644472010312', '644472009941', '644472016338', '644472016321', '644472001945',
      '644472002010', '644472002003', '644472875027', '644472017878', '644472017861', '644472017847', '644472017809', '644472017779', '644472017755', '644472017700',
      '644472017694', '644472014006', '644472013986', '644472013979', '644472013962', '644472013955', '644472013948', '644472013931', '644472013924', '644472012866',
      '644472012859', '644472012842', '644472012835', '644472012804', '644472012798', '644472012781', '644472012743', '644472012736', '644472012712', '644472012682',
      '644472005042', '644472005059', '656825620833', '656825621038', '656825621007', '656825620826', '656825620970', '656825620994', '656825620819', '656825620932',
      '656825620987', '656825620963', '656825620925', '656825620802', '656825620895', '656825620796', '656825620406', '656825620918', '656825620451', '656825620871',
      '656825620741', '656825620864', '656825620789', '656825620710', '656825620512', '656825620437', '656825620727', '656825620413', '656825620673', '656825620772',
      '656825620765', '656825620420', '656825620758', '656825620611', '656825620635', '656825620604', '644472013825', '644472013818', '644472013801', '644472013795',
      '644472007985', '644472000337', '644472008166', '644472017045', '644472017076', '644472050035', '644472018431', '644472018424', '644472006827', '644472006803',
      '644472006797', '644472500035', '644472500059', '644472500028', '644472500066', '644472525038', '644472012262', '644472525052', '644472002904', '644472850529',
      '644472003246', '644472700022', '644472992038', '644472992052', '644472992151', '644472017458', '644472001877', '644472001860', '644472017410', '644472002652',
      '644472002645', '644472850468', '644472011180', '644472011166', '644472111101', '644472111194', '644472111187', '644472000009', '644472010626', '644472010602',
      '644472002836', '644472118100', '644472011906', '644472011890', '644472016116', '644472016109', '644472111156', '644472111132', '644472111149', '644472117103',
      '644472117110', '644472117073', '644472117080', '644472117042', '644472117059', '644472375039', '644472017403', '644472375015', '644472375053', '644472375022',
      '644472375077', '644472375060', '644472005387', '644472005400', '644472005349', '644472005356', '644472350050', '644472350067', '644472100037', '644472100051',
      '644472100068', '644472950038', '644472950052', '644472950069', '644472017182', '644472017199', '644472017489', '644472174595', '644472101331', '644472101430',
      '644472005066', '644472005073', '644472017175', '644472017106', '644472017021', '644472011098', '644472011104', '644472017939', '644472725032', '644472725056',
      '644472700039', '644472700053', '644472018233', '644472010794', '644472010824', '644472825039', '644472825053', '644472825060', '644472925036', '644472925043',
      '644472007664', '644472925012', '644472925050', '644472925029', '644472925067', '644472991024', '644472010930', '644472012651', '644472012705', '644472012422',
      '644472012699', '644472012095', '644472991444', '644472991437', '644472013191', '644472013214', '644472013320', '644472012385', '644472012408', '644472991147',
      '644472011135', '644472014013', '644472013269', '644472013184', '644472013290', '644472012392', '644472013276', '644472011364', '644472012040', '644472013283',
      '644472014020', '644472013252', '644472990737', '644472990744', '644472990751', '644472000603', '644472000597', '644472000580', '644472002423', '644472002782',
      '644472002416', '644472002379', '644472002386', '644472002126', '644472002140', '644472010046', '644472002133', '644472002102', '644472011302', '644472002768',
      '644472002348', '644472002331', '644472002362', '644472006209', '644472002355', '644472002096', '00724089645661', '724089645661', '00724089504463', '724089504463',
      '00727804566555', '727804566555', '00724089647368', '724089647368', '00724089328014', '724089328014', '00724089203212', '724089203212', '00724089202918', '724089202918',
      '00724089202833', '724089202833', '00724089202758', '724089202758', '00724089202321', '724089202321', '00724089114969', '724089114969', '00724089113429', '724089113429',
      '00727804562069', '727804562069', '00727804562076', '727804562076', '00727804562106', '727804562106', '00727804562083', '727804562083', '00727804564575', '727804564575',
      '00727804561659', '727804561659', '00727804564599', '727804564599', '00727804561666', '727804561666', '00727804564582', '727804564582', '00727804561680', '727804561680',
      '00727804564568', '727804564568', '00727804561673', '727804561673', '00727804562274', '727804562274', '00727804562236', '727804562236', '00727804562267', '727804562267',
      '00727804201142', '00727804200138', '00727804562250', '727804562250', '00727804562243', '727804562243', '00727804566562', '727804566562', '00727804566548', '727804566548',
      '00727804566531', '727804566531', '00727804566524', '727804566524', '00727804566517', '727804566517', '00724089849663', '00724089846563', '724089846563', '00724089834201',
      '724089834201', '00724089834126', '724089834126', '00724089794437', '724089794437', '00724089794277', '724089794277', '00724089793621', '724089793621', '00724089793461',
      '724089793461', '00724089792730', '724089792730', '00724089792655', '724089792655', '00724089792143', '724089792143', '00724089682512', '724089682512', '00724089682437',
      '724089682437', '00724089647870', '724089647870', '00724089646552', '724089646552', '00724089646477', '00724089645586', '00724089645319', '00724089645234', '00724089645159',
      '00724089645074', '00724089579607', '724089579607', '00724089579522', '724089579522', '00724089579447', '724089579447', '00727804567514', '727804567514', '00727804567507',
      '727804567507', '00727804566432', '727804566432', '00727804566425', '727804566425', '00727804564780', '727804564780', '00727804564773', '727804564773', '00724089504548',
      '00724089454461', '724089454461', '00724089454386', '724089454386', '00727804333850', '727804333850', '00727804333843', '727804333843', '00727804333416', '727804333416',
      '00724089327710', '724089327710', '00724089256904', '724089256904', '00724089204295', '724089204295', '00724089204103', '724089204103', '00724089204028', '724089204028',
      '00724089203991', '724089203991', '00724089203809', '724089203809', '00724089203724', '724089203724', '00724089203649', '724089203649', '00724089203489', '724089203489',
      '00724089203052', '724089203052', '00724089202673', '724089202673', '00724089202598', '724089202598', '00724089202406', '724089202406', '00724089202246', '724089202246',
      '00724089202161', '724089202161', '00724089202086', '724089202086', '00724089114952', '724089114952', '00724089114945', '724089114945', '00724089114938', '724089114938',
      '00724089114921', '724089114921', '00724089114914', '724089114914', '00724089114242', '00724089114235', '00724089114167', '724089114167', '00724089114112', '724089114112',
      '00724089113474', '724089113474', '00724089113467', '724089113467', '00724089113450', '724089113450', '00724089113443', '724089113443', '00724089113436', '724089113436',
      '00724089113368', '724089113368', '00724089113351', '724089113351', '00724089060983', '724089060983', '00724089060716', '724089060716', '00724089060631', '724089060631',
      '00724089060556', '724089060556', '5060693303319', '5060978810044', '5060978810037', '5060693303357', '5060693303326', '5060978810013', '5060978810006', '5060693303364',
      '5060693303333', '5060978810075', '5060978810068', '5060693303371', '5060693303340', '5060978810105', '5060978810099', '5060693303388', '5060693302022', '5060693302053',
      '5060693302046', '5060693301988', '5060693302015', '5060693301995', '5060693301940', '5060693301971', '5060693301964', '5060693301957', '5060693302657', '5060693302664',
      '5060693302633', '5060693302640', '5060693308321', '5060693308338', '5060693308345', '5060693302732', '5060693302749', '5060693302718', '5060693302725', '5060978812048',
      '5060978812055', '5060978812062', '5060693307874', '5060693307867', '5060693307850', '5060693307881', '5060693303289', '5060693303302', '5060693309090', '5060693309083',
      '5060693309076', '5060693302954', '5060693302923', '5060693302893', '5060693302985', '5060978812321', '5060978812697', '5060978812338', '5060978812864', '5060978812345',
      '5060978812598', '5060978812314', '5060978812390', '5060693307492', '5060693307522', '5060693307461', '5060693307508', '5060693307539', '5060693307478', '5060693307515',
      '5060693307546', '5060693307485', '5060693309700', '5060693309694', '5060693309687', '5060693309717', '5060693309724', '5060693306358', '5060693306365', '5060693306372',
      '5060693306389', '5060693302275', '5060693302268', '5060693302282', '5060693302299', '5060693308079', '5060693308130', '5060693308093', '5060693308154', '5060693308116',
      '5060693308178', '5060693308086', '5060693308147', '5060693308109', '5060693308161', '5060693308123', '5060693308185', '5060693304552', '5060693304590', '5060693304569',
      '5060693304606', '5060693304576', '5060693304613', '5060693304583', '5060693304620', '5060693307904', '5060693307898', '5060693307911', '5060693307928', '5060693305313',
      '5060693305320', '5060693305337', '5060693305283', '5060693305290', '5060693305306', '5060693305252', '5060693305269', '5060693305276', '5060693305405', '5060693305436',
      '5060693305412', '5060693305443', '5060693305429', '5060693305450', '5060693305344', '5060693305375', '5060693305351', '5060693305382', '5060693305368', '5060693305399',
      '5060693306594', '5060693306600', '5060693306617', '5060693304057', '5060693304019', '5060693303975', '5060693304026', '5060693303982', '5060693303944', '5060693304040',
      '5060693304002', '5060693303968', '5060693304033', '5060693303999', '5060693303951', '5060693301292', '5060693301032', '5060693301063', '5060693301025', '5060693301056',
      '5060693301018', '5060693301049', '5060693306532', '5060978810143', '5060693309991', '5060693306525', '5060978810136', '5060693309984', '5060693306518', '5060978810129',
      '5060693309977', '5060693309212', '5060693309205', '5060693309199', '5060693308789', '5060693308796', '5060693308802', '5060693308758', '5060693308765', '5060693308772',
      '5060693308727', '5060693308734', '5060693308741', '5060693301452', '5060693301469', '5060693301445', '5060693309847', '5060693301421', '5060693301438', '5060693301414',
      '5060693309809', '5060693301391', '5060693301407', '5060693301384', '5060693309755', '5060693301483', '5060693301490', '5060693301476', '5060693309861', '5060693306310',
      '5060693303104', '5060693303074', '5060693303081', '5060693303098', '5060693306327', '5060693303067', '5060693303036', '5060693303043', '5060693308895', '5060693306334',
      '5060693303029', '5060693302992', '5060693303005', '5060693303012', '5060693306341', '5060693303142', '5060693303111', '5060693303128', '5060693303135', '5060693306037',
      '5060693306044', '5060693306051', '5060693304279', '5060693306068', '5060693304286', '5060693300196', '5060693300172', '5060693300158', '5060693300219', '5060693308604',
      '5060693308598', '5060693308581', '5060693308574', '5060693308550', '5060693308543', '5060693308536', '5060693308529', '5060693308451', '5060693308444', '5060693308437',
      '5060693308420', '5060693308505', '5060693308475', '5060693308499', '5060693308482', '5060693300998', '5060693300981', '5060693300974', '5060693301001', '5060693300943',
      '5060693300936', '5060693300967', '5060693302244', '5060693302220', '5060693302251', '5060693300134', '5060693300127', '5060693300110', '5060693300141', '5060693301568',
      '5060693301551', '5060693301544', '5060693301575', '5060693306396', '5060693306402', '5060693306419', '5060693306426', '5060693302930', '5060693302909', '5060693302879',
      '5060693302961', '5060693302947', '5060693302916', '5060693302886', '5060693302978', '5060693309014', '5060693308994', '5060978813595', '5060693309007', '5060693308949',
      '5060693308918', '5060693308925', '5060693308932', '5060693308826', '5060693308833', '5060693308840', '5060693308857', '5060693309069', '5060693309038', '5060693309045',
      '5060693309052', '5060978812130', '5060978812352', '5060978812703', '5060978812857', '5060978812307', '5060978812406', '5060978812291', '5060978812413', '5060978812123',
      '5060978812277', '5060978812284', '5060978812383', '5060978812369', '5060978812376', '5060693306907', '5060693306945', '5060693306914', '5060693306952', '5060693306921',
      '5060693306969', '5060693306938', '5060693306976', '5060693304972', '5060693304989', '5060693304996', '5060693305009', '5060693305016', '5060693305023', '5060693305030',
      '5060693305047', '5060693305054', '5060693305061', '5060693309106', '5060693309113', '5060693309120', '5060693309137', '5060693309144', '5060693309656', '5060693309649',
      '5060693309632', '5060693309663', '5060693309670', '5060693303425', '5060693303432', '5060693303449', '5060693303456', '5060693303463', '5060978810051', '5060978810020',
      '5060978810082', '5060693308383', '5060693308376', '5060693308406', '5060693308390', '5060693307225', '5060693307249', '5060693307232', '5060693307256', '5060693304712',
      '5060693304729', '5060693304736', '5060693304743', '5060978812895', '5060978812901', '5060978812918', '5060978812925', '5060693309328', '5060693309304', '5060693309366',
      '5060693309335', '5060693309359', '5060693309373', '5060693309342', '5060693309311', '5060693309243', '5060693309229', '5060693309298', '5060693309267', '5060693309281',
      '5060693309250', '5060693309274', '5060693309236', '5060693309403', '5060693309380', '5060693309458', '5060693309427', '5060693309441', '5060693309410', '5060693309434',
      '5060693309397', '5060693309489', '5060693309465', '5060693309533', '5060693309502', '5060693309526', '5060693309496', '5060693309519', '5060693309472', '5060693302572',
      '5060693302565', '5060693302589', '5060693306006', '5060693302541', '5060693302534', '5060693302558', '5060693306013', '5060693302510', '5060693302503', '5060693302527',
      '5060693306020', '5060693303845', '5060693303852', '5060693303869', '5060693306211', '5060693306228', '5060693306235', '5060693306242', '5060693306136', '5060693306143',
      '5060693306150', '5060693306167', '5060693307034', '5060693307041', '5060693307058', '5060693307065', '5060978812246', '5060978812239', '5060978812253', '5060978812260',
      '5060693307171', '5060693307188', '5060693307195', '5060693307201', '5060693309946', '5060693309939', '5060693309953', '5060693309960', '5060693308628', '5060693308611',
      '5060693308635', '5060693308642', '5060693303517', '5060693303524', '5060693303531', '5060693303548', '5060693304514', '5060693304521', '5060693304538', '5060693304545',
      '5060693308666', '5060693308659', '5060693308673', '5060693308680', '5060693300370', '5060693300363', '5060693300387', '5060693300394', '5060693303203', '5060693303197',
      '5060693303210', '5060693303227', '5060693300042', '5060693300080', '5060693300103', '5060693300035', '5060693300073', '5060693300097', '5060693303234', '5060693303258',
      '5060693303265', '5060693302121', '5060693302107', '5060693302114', '5060693302138', '5060693302084', '5060693302060', '5060693302077', '5060693302091', '5060693302169',
      '5060693302145', '5060693302152', '5060693302176', '5060693302206', '5060693302183', '5060693302190', '5060693302213', '5060693301599', '5060693301582', '5060693301605',
      '5060693301612', '5060693300639', '5060693300622', '5060693300646', '5060693300653', '5060693301711', '5060693301704', '5060693301728', '5060693301735', '5060693309557',
      '5060693309588', '5060693309618', '5060693309564', '5060693309595', '5060693309625', '5060693309540', '5060693309571', '5060693309601', '5060693302442', '5060693302459',
      '5060693302466', '5060693302473', '5060693302480', '5060693302497', '5060693308017', '5060693308024', '5060693308031', '5060693308048', '5060693308055', '5060693308062',
      '5060693308208', '5060693308222', '5060693308246', '5060693308192', '5060693308215', '5060693308239', '5060693301797', '5060693301780', '5060693301803', '5060693301810',
      '5060693303166', '5060693303159', '5060693303173', '5060693303180', '5060693303807', '5060693303814', '5060693303821', '5060693303838', '5060693303470', '5060693303487',
      '5060693303494', '5060693303500', '5060693306488', '5060693301872', '5060978812666', '5060693301858', '5060693301865', '5060693306471', '5060693301841', '5060978812642',
      '5060693301827', '5060693301834', '5060693306495', '5060693301902', '5060978812659', '5060693301889', '5060693301896', '5060693306501', '5060693301933', '5060978812673',
      '5060693301919', '5060693301926', '5060693302824', '5060693302862', '5060693301674', '5060693301667', '5060693301681', '5060693301698', '5060693307331', '5060693307348',
      '5060693307355', '5060693307362', '5060978810204', '5060978810198', '5060978810211', '5060978810228', '5060978810167', '5060978810150', '5060978810174', '5060978810181',
      '5060693306624', '5060693306631', '5060693306648', '5060693306655', '5060693309151', '5060693309168', '5060693309175', '5060693309182', '5060978812932', '5060978812949',
      '5060978812956', '5060978812963', '5060693307416', '5060693307423', '5060693307430', '5060693307447', '5060978812086', '5060978812093', '5060978812109', '5060978812116',
      '5060978811942', '5060978811935', '5060978811959', '5060978811966', '048081011812', '048081604250', '048081001035', '048081008201', '048081008218', '048081008225',
      '048081003701', '048081003725', '048081003732', '048081003749', '048081112021', '048081624753', '048081001059', '048081011416', '048081011423', '048081011454',
      '048081011485', '048081011676', '048081011683', '048081011690', '048081114223', '048081011355', '048081011362', '048081011379', '048081011386', '048081011607',
      '048081011614', '048081011621', '048081011447', '048081011461', '048081031483', '048081511473', '048081011522', '048081001097', '048081012024', '048081011492',
      '048081010051', '048081010068', '048081003824', '048081003831', '048081003848', '048081003855', '048081003862', '048081003879', '048081003886', '048081011508',
      '048081011881', '048081003756', '048081003787', '048081010402', '048081010419', '048081010426', '048081612262', '048081612279', '048081011539', '048081011430',
      '048081021484', '048081511466', '048081011836', '048081011515', '048081609354', '048081011546', '048081010501', '048081010518', '048081011584', '048081011348',
      '048081011553', '048081612286', '048081033005', '048081011409', '048081011638', '048081011645', '048081010204', '048081010228', '048081609552', '48081620000',
      '048081620001', '048081011560', '048081621776', '048081011591', '048081010938', '048081010945', '048081010952', '048081011737', '048081011713', '048081604205',
      '048081604229', '048081629017', '048081301043', '048081620922', '048081003718', '048081003763', '048081711408', '048081010808', '048081623879', '048081625194',
      '048081626764', '048081604212', '048081625538', '048081629024', '048081622506', '048081011829', '048081211601', '048081311608', '048081411605', '048081211618',
      '048081311615', '048081411612', '048081620915', '048081011744', '048081021187', '048081021194', '048081721209', '048081021217', '048081036624', '048081621912',
      '048081602447', '048081010822', '048081217153', '048081626191', '048081626733', '048081625477', '048081624838', '048081624951', '048081626795', '048081623770',
      '048081625446', '048081625422', '048081625415', '048081623909', '048081211625', '048081311622', '048081411629', '048081211670', '048081311677', '048081111673',
      '048081010044', '048081010082', '048081010099', '048081132067', '048081028209', '048081028216', '048081018224', '048081028223', '048081011652', '048081602430',
      '048081602454', '048081021132', '048081021149', '048081010709', '048081010716', '048081010723', '048081010907', '048081010921', '048081011201', '048081032046',
      '048081032022', '048081625033', '048081626726', '048081609422', '048081624982', '048081625040', '048081625484', '048081626771', '048081628058', '048081625408',
      '048081625439', '048081612187', '048081612231', '048081612248', '048081211632', '048081311639', '048081111635', '048081211687', '048081311684', '048081111680',
      '048081011850', '048081900154', '048081900123', '048081900130', '048081010457', '048081010464', '048081010471', '048081010488', '048081602461', '048081602478',
      '048081010815', '048081011218', '048081900116', '048081032008', '048081032015', '048081999028', '048081625118', '048081625088', '048081609538', '048081628218',
      '048081011874', '048081612071', '048081012437', '048081003626', '048081003633', '048081211694', '048081311691', '048081111697', '048081625163', '048081628195',
      '048081602409', '048081602485', '048081010969', '048081010976', '048081011003', '048081004883', '048081138205', '048081999011', '048081999202', '048081624081',
      '048081625095', '048081625149', '048081621554', '048081621608', '048081628201', '048081628102', '048081211649', '048081311646', '048081311642', '048081001073',
      '048081010105', '048081010112', '048081010129', '048081010617', '48081621813', '048081621813', '48081621844', '048081621844', '048081623688', '048081609590',
      '048081602492', '048081626375', '048081625217', '048081621547', '048081621561', '048081012444', '048081064009', '048081064016', '048081064023', '048081064061',
      '048081623954', '048081623992', '048081011706', '048081628126', '048081032039', '048081628089', '048081628096', '048081626047', '048081064030', '048081211656',
      '048081311653', '048081111659', '048081010532', '048081625125', '048081311400', '048081035054', '048081609576', '048081628072', '048081609583', '048081021224',
      '048081626719', '048081609545', '048081626061', '048081125007', '048081180259', '048081609484', '048081110355', '048081609613', '048081625231', '048081609606',
      '048081626627', '048081602508', '048081602522', '048081075029', '048081017104', '048081021163', '048081021170', '048081021262', '048081110294', '048081110300',
      '048081110324', '048081110331', '048081900161', '048081900178', '048081900185', '048081619247', '048081619209', '048081626818', '048081623756', '048081180358',
      '048081602416', '048081628188', '048081400968', '048081400975', '048081400982', '048081609620', '048081628119', '048081035009', '048081625644', '048081071519',
      '048081010983', '048081400906', '048081813041', '048081713044', '048081627051', '048081007082', '048081031001', '048081111482', '048081211489', '048081311486',
      '048081623763', '048081064047', '048081075036', '048081626658', '048081125052', '048081400920', '048081014851', '048081626078', '048081624708', '048081609446',
      '048081007105', '048081034859', '048081400951', '048081624722', '048081071007', '048081216149', '048081018149', '048081624746', '048081612415', '048081918180',
      '048081071144', '048081210086', '048081220061', '048081518045', '048081212424', '048081112410', '048081315125', '097612346114', '097612300130', '097612210255',
      '97612071511', '097612071511', '097612343366', '097612092172', '097612092134', '097612346107', '97612092288', '097612092288', '97612091052', '097612091052',
      '97612071504', '097612071504', '097612052183', '097612008906', '097612370058', '097612347548', '097612347395', '097612343489', '097612112009', '97612092516',
      '097612092516', '097612008630', '097612450125', '097612400434', '097612361506', '097612321708', '097612320893', '097612320756', '097612151244', '097612118513',
      '097612091113', '097612091069', '097612083255', '097612023275', '097612921502', '097612910322', '097612910100', '097612790207', '097612752045', '097612750249',
      '097612720105', '097612701586', '097612661040', '097612660302', '097612501001', '097612403091', '097612401325', '097612401318', '097612401035', '097612401028',
      '097612401011', '097612400670', '097612400496', '097612390605', '097612370072', '097612361254', '097612348545', '097612343243', '097612340136', '097612340112',
      '097612340068', '097612325508', '097612321203', '097612321104', '097612320794', '097612320763', '097612320749', '097612300314', '097612300253', '097612242102',
      '097612210231', '097612210224', '097612210217', '097612210101', '097612210019', '097612201635', '097612201628', '097612201314', '097612200935', '097612200225',
      '097612180305', '097612180251', '097612180206', '097612180145', '097612180121', '097612180107', '097612152548', '097612138030', '097612117103', '097612092110',
      '97612091557', '097612091557', '097612091427', '97612091328', '097612091328', '097612091236', '97612090635', '097612090635', '097612057188', '097612052244',
      '097612051186', '097612041026', '097612008883', '97612980905', '97612980752', '97612980509', '097612970357', '097612951103', '097612950175', '097612950151',
      '097612950120', '097612950106', '097612930108', '097612925500', '097612925401', '097612925203', '097612924121', '097612924114', '097612924107', '097612924091',
      '97612923636', '97612923629', '97612923612', '97612923605', '97612923506', '097612923407', '097612923308', '097612923209', '097612921403', '097612921304',
      '097612921205', '097612920505', '097612920406', '097612920307', '097612920208', '097612920109', '097612910315', '097612910308', '097612910278', '097612910261',
      '97612910247', '097612910216', '097612910025', '097612910018', '97612840643', '097612840087', '097612840049', '097612840025', '097612811162', '097612810325',
      '097612810080', '097612810042', '097612800319', '097612800302', '097612800227', '097612800210', '097612800128', '97612791105', '097612790245', '097612790214',
      '097612790115', '097612790108', '097612790085', '097612780246', '097612780086', '097612780048', '097612770209', '097612770100', '097612762556', '097612762457',
      '097612762358', '097612762150', '097612760200', '097612760101', '097612754087', '097612753240', '097612753103', '097612752304', '097612752243', '097612752106',
      '097612751246', '097612751086', '097612751048', '097612750089', '097612750041', '097612743104', '097612742107', '97612741087', '097612740202', '097612740103',
      '097612740011', '097612701579', '097612701562', '097612701555', '097612701432', '097612701425', '097612701418', '097612701401', '097612701296', '097612701272',
      '097612701166', '097612701159', '097612701111', '097612701104', '97612701067', '097612701050', '097612660401', '097612660203', '097612660104', '097612660050',
      '97612624014', '097612624007', '097612623017', '097612623000', '097612622508', '097612622201', '097612622119', '097612622102', '097612622003', '097612621549',
      '097612621532', '097612621525', '97612621501', '097612610222', '097612610215', '097612610208', '097612610109', '097612520101', '097612520033', '097612520019',
      '097612511116', '097612511109', '097612510119', '097612510102', '97612500905', '097612500509', '097612500257', '97612450156', '097612450118', '097612450101',
      '097612410518', '097612410501', '097612410228', '097612410211', '097612410112', '097612403220', '097612403190', '097612403183', '097612403152', '097612403114',
      '097612403107', '097612403084', '097612403046', '097612403039', '097612403022', '097612403015', '097612402797', '097612402780', '097612402773', '097612402759',
      '097612402742', '097612402735', '097612402483', '097612402476', '97612402452', '97612402124', '97612402117', '097612402100', '097612402056', '97612402032',
      '97612402025', '97612402018', '097612401844', '097612401837', '97612401806', '097612401714', '097612401707', '97612401639', '097612401622', '097612401615',
      '097612401608', '097612401554', '097612401523', '097612401516', '097612401509', '097612401462', '097612401455', '097612401448', '097612401431', '097612401417',
      '097612401400', '097612401370', '097612401363', '97612401332', '097612401301', '97612401226', '097612401219', '97612401202', '97612401134', '097612401127',
      '097612401110', '097612401103', '097612401066', '097612401042', '097612401004', '097612400991', '097612400984', '097612400977', '097612400939', '097612400922',
      '097612400878', '97612400861', '97612400854', '97612400816', '97612400809', '097612400779', '97612400762', '97612400731', '097612400724', '097612400700',
      '97612400687', '97612400663', '97612400656', '097612400595', '097612400564', '97612400540', '097612400533', '097612400526', '097612400472', '097612400441',
      '097612400427', '097612400410', '097612400397', '097612400380', '97612400359', '097612400342', '097612400335', '097612400328', '097612400311', '097612400304',
      '097612400267', '097612400205', '097612400199', '097612400182', '097612400175', '097612400168', '097612400144', '97612400120', '097612391107', '097612391060',
      '097612391046', '097612391022', '097612391008', '097612390612', '097612390407', '097612390254', '097612376005', '097612375039', '097612371505', '97612371000',
      '097612370614', '097612370607', '097612370409', '097612370256', '097612370102', '97612370034', '097612370027', '097612370010', '97612362756', '097612362510',
      '97612362503', '097612362404', '097612362251', '97612362008', '97612361001', '97612360752', '97612360509', '097612360400', '097612360257', '097612360219',
      '097612360202', '97612360011', '97612350135', '97612350043', '97612350036', '097612348392', '097612348248', '097612348156', '097612347241', '097612347159',
      '97612345056', '097612343182', '097612340488', '097612340365', '097612340242', '097612340181', '097612340143', '97612340105', '97612340051', '097612340020',
      '097612332506', '097612331509', '097612331400', '097612331257', '097612331004', '097612330755', '097612330502', '097612328059', '097612327120', '097612327113',
      '097612327106', '97612326505', '97612326406', '097612326307', '097612326208', '097612326109', '097612326000', '097612325706', '097612325607', '097612325188',
      '97612325126', '097612325003', '097612324105', '097612322811', '097612322804', '097612322361', '097612322354', '97612322347', '097612322286', '097612322255',
      '97612322033', '097612322026', '097612322019', '097612322002', '097612321807', '097612321500', '097612321302', '097612321012', '097612321005', '097612320961',
      '97612320954', '097612320923', '097612320916', '097612320909', '097612320886', '97612320879', '97612320862', '97612320855', '97612320831', '97612320824',
      '097612320817', '097612320800', '097612320787', '097612320770', '097612320732', '097612320725', '097612320718', '097612320701', '97612320503', '097612313154',
      '097612313109', '097612313062', '097612313031', '097612311501', '097612311006', '097612310603', '097612310405', '097612310252', '097612303537', '097612303520',
      '097612303513', '097612303506', '97612301502', '97612301007', '97612300505', '097612300321', '97612300291', '097612300284', '97612300277', '097612300260',
      '097612300246', '097612300222', '097612300215', '097612300208', '97612300154', '097612300147', '097612300109', '097612300086', '097612300079', '097612300062',
      '097612300055', '097612300031', '097612300024', '097612300017', '97612260908', '97612260205', '097612260045', '097612260021', '097612260014', '97612260007',
      '97612251029', '097612245080', '097612245042', '097612245028', '97612244113', '097612243857', '97612242317', '097612242294', '097612242270', '97612242263',
      '97612242256', '97612242249', '097612242225', '097612242218', '097612242119', '097612242072', '97612242065', '097612242058', '097612242041', '097612242034',
      '097612242027', '097612242010', '097612241419', '097612241402', '097612241358', '097612241259', '097612241242', '097612241235', '097612241228', '097612241211',
      '097612241204', '097612241105', '097612241051', '097612241020', '097612241013', '097612240757', '097612240719', '097612240702', '097612240658', '097612240603',
      '97612240511', '097612240504', '097612240412', '097612240313', '97612240306', '097612240214', '97612240207', '097612240115', '97612240108', '097612240092',
      '097612240085', '097612240061', '097612240047', '097612240030', '097612240023', '097612240016', '97612210248', '097612210200', '97612210149', '097612210132',
      '097612210125', '097612210118', '097612210033', '097612210026', '97612201963', '97612201949', '97612201932', '97612201925', '97612201918', '097612201857',
      '097612201840', '097612201833', '097612201826', '097612201819', '097612201642', '097612201604', '097612201536', '097612201529', '097612201512', '097612201451',
      '097612201406', '097612201352', '097612201345', '097612201338', '097612201321', '097612200959', '097612200942', '097612200928', '097612200911', '097612200867',
      '097612200850', '097612200843', '097612200836', '097612200829', '097612200812', '097612200300', '097612200294', '097612200287', '097612200256', '97612200249',
      '097612200232', '097612200218', '097612180763', '097612180756', '097612180749', '097612180732', '097612180725', '097612180718', '097612180657', '097612180640',
      '097612180633', '097612180626', '097612180619', '097612180602', '097612180534', '097612180527', '097612180398', '097612180381', '97612180374', '097612180367',
      '097612180350', '097612180343', '097612180336', '097612180329', '097612180312', '97612180299', '97612180282', '97612180275', '97612180268', '097612180244',
      '097612180237', '097612180220', '097612180213', '97612180190', '97612180183', '97612180176', '97612180169', '097612180152', '97612180138', '097612180114',
      '97612155549', '97612155396', '97612155242', '97612154542', '097612154399', '97612154245', '097612153545', '097612153392', '97612153248', '97612152395',
      '97612152241', '97612151541', '097612151398', '97612140101', '97612140026', '097612139044', '97612138085', '097612134124', '097612134087', '097612134032',
      '97612133127', '097612133080', '097612133035', '97612123005', '97612121506', '97612121001', '97612120509', '97612120257', '097612120141', '097612120134',
      '097612120110', '097612120103', '097612119114', '097612119091', '097612119084', '097612118605', '097612118506', '097612118438', '097612118414', '097612118315',
      '097612118308', '097612118216', '097612118209', '097612118117', '097612118100', '97612118049', '97612118032', '097612118018', '097612118001', '97612115000',
      '097612114102', '097612114003', '097612113105', '097612113006', '097612111101', '097612111002', '097612110609', '097612110555', '097612110524', '097612110517',
      '097612110500', '097612110012', '097612104011', '97612103748', '097612103717', '097612103687', '097612103625', '97612103588', '097612103526', '97612092509',
      '97612092295', '097612092295', '097612092165', '097612092158', '097612092127', '097612092103', '097612092097', '097612092080', '97612091632', '97612091625',
      '97612091618', '97612091601', '097612091571', '97612091564', '97612091533', '97612091526', '97612091519', '097612091496', '097612091489', '097612091465',
      '97612091434', '97612091403', '097612091397', '097612091359', '097612091335', '097612091311', '97612091298', '097612091298', '97612091281', '097612091281',
      '97612091274', '097612091274', '97612091267', '097612091267', '97612091243', '097612091243', '097612091182', '97612091175', '097612091151', '097612091144',
      '097612091137', '097612091120', '097612091106', '097612091090', '097612091076', '97612091045', '097612091045', '97612091038', '097612091038', '97612091021',
      '097612091021', '97612091014', '097612091014', '97612090628', '097612090628', '97612090611', '097612090611', '97612090604', '097612090604', '97612090550',
      '097612090550', '97612090529', '097612090529', '97612090512', '097612090512', '97612090420', '97612090413', '097612090406', '97612090307', '97612085259',
      '97612085150', '97612083156', '097612081251', '097612081152', '97612057485', '97612057362', '97612057249', '097612056488', '97612056365', '97612056242',
      '97612056181', '97612055481', '97612055368', '97612055245', '97612055184', '97612054484', '97612054361', '97612054248', '97612054187', '097612054019',
      '97612053487', '97612053364', '97612053241', '97612053180', '97612053012', '97612052480', '97612052367', '97612051483', '97612051360', '097612051247',
      '097612041057', '097612041040', '097612041033', '97612041019', '097612033168', '097612033151', '097612033144', '097612033137', '097612033120', '097612033113',
      '97612027051', '97612027044', '97612027020', '097612027013', '97612024760', '97612024326', '097612024302', '97612023756', '097612023701', '097612023503',
      '097612023268', '097612023251', '097612023220', '097612023206', '097612023190', '097612023183', '97612023107', '097612023053', '097612023022', '097612023015',
      '097612021042', '97612020106', '97612019483', '97612019360', '97612019247', '97612019209', '97612019018', '97612018486', '097612018363', '97612018240',
      '97612018202', '97612016482', '97612016185', '97612013481', '097612009910', '097612009903', '97612009873', '97612009859', '97612009828', '097612009811',
      '097612009804', '097612009712', '097612009705', '097612009620', '097612009613', '097612009606', '097612009552', '97612009538', '97612009521', '97612009514',
      '097612009507', '97612009491', '97612009422', '097612009408', '97612009385', '97612009378', '097612009361', '097612009354', '097612009309', '097612009262',
      '097612009255', '97612009248', '097612009231', '97612009224', '097612009217', '097612009200', '097612009125', '97612009118', '97612009101', '097612008852',
      '097612008821', '097612008807', '097612008753', '097612008715', '097612008708', '097612008654', '97612008616', '097612008609', '097612008531', '097612008517',
      '097612008364', '097612008357', '097612008302', '097612008210', '097612008203', '097612008159', '097612008111', '097612008104', '097612008067', '097612008050',
      '097612006209'
    ],

    // Collections whose products should have the autoship widget hidden,
    // regardless of individual product UPC. `handle` is the collection's
    // URL slug (from /collections/<handle>) — Shopify's public products.json
    // endpoint only works by handle, not numeric ID, so both are kept here
    // for reference/debugging even though only `handle` is used at runtime.
    blockedCollections: [
      { id: '276855521471', handle: 'prevue' },
      { id: '430754758910', handle: 'a-e-cage-company-1' },
      { id: '276815577279', handle: 'petmate' }, //remove after UPC addition to Petmate
      { id: '487779860734', handle: 'hikari'}  //hikari collection
    ],
    collectionProductsPageSize: 250,
    collectionProductsMaxPages: 20, // safety cap: 20 * 250 = 5000 products/collection

    debounceMs    : 60,
    retryDelays   : [100, 300, 600, 1200, 2500, 5000],
    reassertDelays: [250, 750, 1500],
    selectors: {
      widgetRoot       : '.sealsubs-target-element',
      sealsubsContainer: '.sealsubs-container',          // ← the whole widget
      optionContainer  : '.sls-option-container',
      purchaseWrapper  : '.sls-purchase-options-container',
      autoshipContainer: '.sls-option-container[data-selling-plan-group="0"]',
      autoshipRadioRow : '[role="radio"][aria-label="Autoship"]',
      oneTimeContainer : '.sls-option-container:not([data-selling-plan-group])',
      oneTimeRadio     : 'input[value="one_time"]',
      oneTimeRadioRow  : '[role="radio"][aria-label="One time"]',
      sellingPlanInput : 'input[name="selling_plan"]',
    },
    autoshipKeywords: ['autoship', 'subscribe', 'subscription']
  };

  var STATE = {
    observer        : null,
    debounceTimer   : null,
    retryTimers     : [],
    reassertTimers  : [],
    lastUrl         : location.href,
    lastVariantId   : null,
    lastBlocked     : null,
    variantMap      : null,
    blockedSet      : null,
    productId       : null,   // cache of the current page's product ID
    blockedCollectionProductIds: null, // Set of product IDs in blocked collections
    collectionListReady : false,
    collectionListLoading: false,
    syncing         : false,
    observerPaused  : false,
    fetchPatched    : false,
    xhrPatched      : false,
    origPush        : null,
    origReplace     : null
  };

  function nodeMatches(node, selector) {
    try {
      var fn = node.matches || node.msMatchesSelector || node.webkitMatchesSelector;
      return fn ? fn.call(node, selector) : false;
    } catch (e) { return false; }
  }

  /* ─────────────────────────────────────────────
     UPC BLOCKLIST (synchronous — built once from CFG.blockedUPCs, no
     network round trip, no dependency on script-tag src resolution)
  ───────────────────────────────────────────── */
  function getBlockedSet() {
    if (!STATE.blockedSet) {
      STATE.blockedSet = {};
      CFG.blockedUPCs.forEach(function (u) {
        STATE.blockedSet[String(u).trim()] = true;
      });
    }
    return STATE.blockedSet;
  }

  function buildVariantMap() {
    if (STATE.variantMap) return STATE.variantMap;
    var scripts = document.querySelectorAll('script[type="application/json"]');
    for (var i = 0; i < scripts.length; i++) {
      var raw = scripts[i].innerHTML;
      if (raw.indexOf('"variants"') === -1) continue;
      try {
        var data = JSON.parse(raw);
        if (!data || !data.product || !data.product.variants) continue;
        var map = {};
        data.product.variants.forEach(function (v) {
          map[String(v.id)] = v.barcode ? String(v.barcode).trim() : '';
        });
        STATE.variantMap = map;
        return map;
      } catch (e) {}
    }
    STATE.variantMap = {};
    return STATE.variantMap;
  }

  /* ─────────────────────────────────────────────
     COLLECTION MEMBERSHIP (fetch-based)
     Shopify doesn't expose a product's collection IDs to
     storefront scripts, but it does expose, per collection
     HANDLE, a public/no-auth product listing:
       /collections/<handle>/products.json?limit=250&page=N
     So instead of asking "what collections is this product in",
     we ask "is this product's ID in each blocked collection's
     product list" — fetched once per page load and cached.
  ───────────────────────────────────────────── */
  function getCurrentProductId() {
    if (STATE.productId) return STATE.productId;

    var el = document.querySelector('[data-product-id]');
    if (el) {
      var attrId = el.getAttribute('data-product-id');
      if (attrId) { STATE.productId = String(attrId).trim(); return STATE.productId; }
    }

    var scripts = document.querySelectorAll('script[type="application/json"]');
    for (var i = 0; i < scripts.length; i++) {
      var raw = scripts[i].innerHTML;
      if (raw.indexOf('"variants"') === -1) continue;
      try {
        var data = JSON.parse(raw);
        if (data && data.product && data.product.id != null) {
          STATE.productId = String(data.product.id);
          return STATE.productId;
        }
      } catch (e) {}
    }

    return null;
  }

  function fetchCollectionProductIds(handle) {
    var ids = [];
    var pageSize = CFG.collectionProductsPageSize;
    var maxPages = CFG.collectionProductsMaxPages;

    function fetchPage(page) {
      var url = '/collections/' + encodeURIComponent(handle) + '/products.json'
        + '?limit=' + pageSize + '&page=' + page;
      return fetch(url, { credentials: 'omit' })
        .then(function (res) {
          if (!res.ok) throw new Error('collection fetch HTTP ' + res.status + ' for ' + handle);
          return res.json();
        })
        .then(function (data) {
          var products = (data && data.products) || [];
          products.forEach(function (p) {
            if (p && p.id != null) ids.push(String(p.id));
          });
          if (products.length === pageSize && page < maxPages) {
            return fetchPage(page + 1);
          }
        });
    }

    return fetchPage(1).then(function () { return ids; }).catch(function (err) {
      return []; // fail soft for this collection; others still apply
    });
  }

  function loadBlockedCollectionProductIds() {
    if (STATE.collectionListReady || STATE.collectionListLoading) return;
    STATE.collectionListLoading = true;

    var fetches = CFG.blockedCollections.map(function (c) {
      return fetchCollectionProductIds(c.handle);
    });

    Promise.all(fetches).then(function (results) {
      var set = {};
      results.forEach(function (idList) {
        idList.forEach(function (id) { set[id] = true; });
      });
      STATE.blockedCollectionProductIds = set;
      STATE.collectionListReady   = true;
      STATE.collectionListLoading = false;
      forceSync(); // re-evaluate now that collection membership is known
    }).catch(function () {
      STATE.collectionListLoading = false;
      setTimeout(loadBlockedCollectionProductIds, 3000);
    });
  }

  function isInBlockedCollection() {
    var set = STATE.blockedCollectionProductIds;
    if (!set) return false; // not loaded yet; UPC check still applies
    var productId = getCurrentProductId();
    if (!productId) return false;
    return !!set[productId];
  }

  function getCurrentVariantId() {
    var match = location.search.match(/[?&]variant=(\d+)/);
    if (match) return match[1];
    var sel = document.querySelector(
      'select[name="id"], input[name="id"][type="hidden"], input[name="id"]'
    );
    if (sel && sel.value) return String(sel.value);
    var map = buildVariantMap();
    var ids = Object.keys(map);
    return ids.length ? ids[0] : null;
  }

  function shouldBlock() {
    // Collection-level block applies regardless of variant/UPC.
    if (isInBlockedCollection()) return true;

    var id = getCurrentVariantId();
    if (!id) return false;
    var upc = buildVariantMap()[id];
    if (!upc) return false;
    return !!getBlockedSet()[upc];
  }

  function pauseObserver()  { STATE.observerPaused = true;  }
  function resumeObserver() { STATE.observerPaused = false; }

  function clearReasserts() {
    STATE.reassertTimers.forEach(clearTimeout);
    STATE.reassertTimers = [];
  }

  /* ─────────────────────────────────────────────
     HIDE ENTIRE WIDGET + FORCE ONE-TIME SELLING PLAN
     We hide the sealsubs-container visually but still
     clear the selling_plan so Shopify treats it as a
     one-time purchase at checkout (no subscription).
  ───────────────────────────────────────────── */
  function hideWidget(scope) {
    var s = scope || document;
    var container = s.querySelector(CFG.selectors.sealsubsContainer);
    if (!container) return false;  // not in DOM yet

    pauseObserver();

    // Hide the whole purchase-options widget
    container.style.setProperty('display', 'none', 'important');
    container.setAttribute('data-ar-widget-hidden', '1');
    container.setAttribute('aria-hidden', 'true');

    // Clear selling_plan so it's a plain one-time add-to-cart
    var planInput = s.querySelector(CFG.selectors.sellingPlanInput);
    if (planInput && planInput.value !== '') {
      planInput.value = '';
      planInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    // Also check the one-time radio internally (belt-and-suspenders)
    var otContainer = s.querySelector(CFG.selectors.oneTimeContainer);
    if (otContainer) {
      var otRadio = otContainer.querySelector(CFG.selectors.oneTimeRadio);
      if (otRadio && !otRadio.checked) {
        otRadio.checked = true;
        otRadio.setAttribute('checked', 'checked');
        otRadio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    resumeObserver();
    return true;
  }

  /* ─────────────────────────────────────────────
     REASSERT: SealSubs sometimes re-injects
     selling_plan after our changes. Re-clear it.
  ───────────────────────────────────────────── */
  function scheduleReasserts() {
    clearReasserts();
    CFG.reassertDelays.forEach(function (ms) {
      var t = setTimeout(function () {
        if (!shouldBlock()) return;

        pauseObserver();

        // Keep widget hidden
        var container = document.querySelector(CFG.selectors.sealsubsContainer);
        if (container && container.style.display !== 'none') {
          container.style.setProperty('display', 'none', 'important');
        }

        // Keep selling_plan cleared
        var planInput = document.querySelector(CFG.selectors.sellingPlanInput);
        if (planInput && planInput.value !== '') {
          planInput.value = '';
          planInput.dispatchEvent(new Event('change', { bubbles: true }));
        }

        resumeObserver();
      }, ms);
      STATE.reassertTimers.push(t);
    });
  }

  /* ─────────────────────────────────────────────
     SHOW WIDGET  (restore for non-blocked UPCs/collections)
  ───────────────────────────────────────────── */
  function showWidget(scope) {
    var s = scope || document;

    pauseObserver();

    var container = s.querySelector('[data-ar-widget-hidden="1"]');
    if (container) {
      container.style.removeProperty('display');
      container.removeAttribute('data-ar-widget-hidden');
      container.removeAttribute('aria-hidden');
    }

    // Restore aria-checked to match whichever radio is actually checked
    var checkedRadio = s.querySelector('input.sls-option:checked');
    if (checkedRadio) {
      var row = checkedRadio.closest('[role="radio"]');
      if (row) row.setAttribute('aria-checked', 'true');
    }

    resumeObserver();
  }

  /* ─────────────────────────────────────────────
     CORE SYNC
  ───────────────────────────────────────────── */
  function syncAutoship() {
    if (STATE.syncing) return;
    STATE.syncing = true;

    try {
      var variantId = getCurrentVariantId();
      var blocked   = shouldBlock();

      if (variantId !== null &&
          variantId === STATE.lastVariantId &&
          blocked    === STATE.lastBlocked) {
        return;
      }

      if (blocked) {
        var hidden = hideWidget();
        if (!hidden) return; // DOM not ready — retries will catch it
        scheduleReasserts();
        STATE.lastVariantId = variantId;
        STATE.lastBlocked   = true;
      } else {
        clearReasserts();
        showWidget();
        STATE.lastVariantId = variantId;
        STATE.lastBlocked   = false;
      }
    } finally {
      STATE.syncing = false;
    }
  }

  function scheduleSync() {
    clearTimeout(STATE.debounceTimer);
    STATE.debounceTimer = setTimeout(function () {
      requestAnimationFrame(syncAutoship);
    }, CFG.debounceMs);
  }

  function forceSync() {
    STATE.lastVariantId = null;
    STATE.lastBlocked   = null;
    STATE.productId     = null; // re-detect product ID (collection list itself stays cached)
    scheduleSync();
  }

  function onUrlChange() {
    if (location.href !== STATE.lastUrl) {
      STATE.lastUrl     = location.href;
      STATE.variantMap  = null;
      STATE.productId   = null;
      forceSync();
    }
  }

  function setupObserver() {
    if (!window.MutationObserver || !document.body) return;

    STATE.observer = new MutationObserver(function (mutations) {
      if (STATE.observerPaused) return;

      var relevant = false;
      outer: for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          if (
            nodeMatches(node, '.sls-option-container')          ||
            nodeMatches(node, '.sls-purchase-options-container') ||
            nodeMatches(node, '.sealsubs-target-element')        ||
            nodeMatches(node, '.sealsubs-container')             ||
            (node.querySelector && node.querySelector(CFG.selectors.optionContainer))
          ) {
            relevant = true;
            break outer;
          }
        }
      }

      if (relevant) {
        STATE.lastVariantId = null;
        STATE.lastBlocked   = null;
        scheduleSync();
      }
    });

    STATE.observer.observe(document.body, { childList: true, subtree: true });
  }

  function setupEvents() {
    [
      'variantChange', 'variant:changed',
      'shopify:section:load', 'shopify:block:select',
      'product:updated', 'page:load',
      'turbolinks:load', 'turbo:load'
    ].forEach(function (name) {
      document.addEventListener(name, forceSync, { passive: true });
    });

    document.addEventListener('change', function (e) {
      var t = e.target;
      if (
        (t.tagName === 'SELECT' && t.name === 'id') ||
        (t.tagName === 'INPUT'  && t.name === 'id')
      ) forceSync();
    }, { passive: true });

    STATE.origPush    = history.pushState;
    STATE.origReplace = history.replaceState;
    history.pushState = function () {
      STATE.origPush.apply(this, arguments);
      onUrlChange();
    };
    history.replaceState = function () {
      STATE.origReplace.apply(this, arguments);
      onUrlChange();
    };
    window.addEventListener('popstate',   onUrlChange, { passive: true });
    window.addEventListener('hashchange', forceSync,   { passive: true });

    if (typeof jQuery !== 'undefined') {
      jQuery(document).ajaxComplete(function () {
        STATE.variantMap = null;
        STATE.productId  = null;
        forceSync();
      });
    }

    patchFetch();
    patchXHR();
  }

  function patchFetch() {
    if (STATE.fetchPatched || typeof window.fetch !== 'function') return;
    STATE.fetchPatched = true;
    var orig = window.fetch;
    window.fetch = function (input) {
      var url = (input && input.url) ? input.url : String(input || '');
      var p   = orig.apply(this, arguments);
      if (url.indexOf('/products/') !== -1 || url.indexOf('variant') !== -1) {
        p.then(forceSync).catch(function () {});
      }
      return p;
    };
  }

  function patchXHR() {
    if (STATE.xhrPatched || typeof XMLHttpRequest === 'undefined') return;
    STATE.xhrPatched = true;
    var origOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      this._arUrl = url || '';
      origOpen.apply(this, arguments);
    };
    var origSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function () {
      if (
        this._arUrl.indexOf('/products/') !== -1 ||
        this._arUrl.indexOf('variant')    !== -1
      ) {
        this.addEventListener('load', forceSync, { passive: true, once: true });
      }
      origSend.apply(this, arguments);
    };
  }

  function scheduleRetries() {
    CFG.retryDelays.forEach(function (ms) {
      var t = setTimeout(function () {
        if (STATE.lastVariantId !== null) return;
        syncAutoship();
      }, ms);
      STATE.retryTimers.push(t);
    });
  }

  function destroy() {
    if (STATE.observer) {
      STATE.observer.disconnect();
      STATE.observer = null;
    }
    clearTimeout(STATE.debounceTimer);
    STATE.retryTimers.forEach(clearTimeout);
    STATE.retryTimers = [];
    clearReasserts();
    if (STATE.origPush)    { history.pushState    = STATE.origPush;    STATE.origPush    = null; }
    if (STATE.origReplace) { history.replaceState = STATE.origReplace; STATE.origReplace = null; }
  }

  function init() {
    loadBlockedCollectionProductIds();  // async — resolves shortly after load
    syncAutoship();
    setupObserver();
    setupEvents();
    scheduleRetries();
  }

  window.__autoshipRemover = { destroy: destroy };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

})();